import { IndividualSummaryDetailCourse } from './useIndividualStageSummaryDetails';
import { Box, Text, Flex, Badge } from '@chakra-ui/react';
import { CourseCard } from './CourseCard';
import { useLocalization } from '~/framework';

type CourseListProps = {
   title: string;
   subtitle: string;
   courses: IndividualSummaryDetailCourse[];
   status: 'Complete' | 'Incomplete' | 'Urgent';
};

export function CourseList({ courses, title, subtitle, status }: CourseListProps) {
   const { ___p } = useLocalization();
   return (
      <>
         <Box as="section" mt="10">
            <Flex alignItems="center">
               <Text variant="title">{title}</Text>
               <Badge
                  ml="3"
                  borderRadius="50%"
                  border={status === 'Urgent' ? 'none' : '1px'}
                  borderColor="gray"
                  backgroundColor={status === 'Urgent' ? 'red.500' : 'white'}
                  color={status === 'Urgent' ? 'white' : 'black'}
                  textAlign="center"
                  minW="7"
                  h="7"
                  lineHeight="7"
               >
                  <Text
                     fontSize="sm"
                     aria-label={___p(
                        courses.length,
                        '%1 Course',
                        '%1 Courses',
                        `${courses.length}`
                     )}
                  >
                     {courses.length}
                  </Text>
               </Badge>
            </Flex>
            <Text variant="muted" fontSize="sm">
               {subtitle}
            </Text>
         </Box>
         <Box as="section" mt="10">
            <Flex
               direction={{ base: 'column', sm: 'row' }}
               flexWrap="wrap"
               justify={{ base: 'space-between', lg: 'flex-start' }}
               columnGap={{ lg: '1.5rem' }}
            >
               {courses.map(course => (
                  <CourseCard key={course.course_assignmentid} course={course} />
               ))}
            </Flex>
         </Box>
      </>
   );
}
